import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/vincepicone/Programming/Work/carbon-website/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "content-design-can-make-or-break-an-online-experience-always-strive-for-writing-that-is-clear-concise-and-on-brand"
    }}>{`Content design can make or break an online experience. Always strive for writing that is clear, concise, and on-brand.`}</h3>
    <h2 {...{
      "id": "voice-and-tone"
    }}>{`Voice and tone`}</h2>
    <p>{`Consistent voice and tone are crucial for connecting and resonating with users. What’s the difference between voice and tone? One way to think about it is that voice is always consistent, but tone often changes depending on context.`}</p>
    <h3 {...{
      "id": "voice"
    }}>{`Voice`}</h3>
    <p>{`Voice is the foundation for communicating about IBM products and delivering brand messages. At IBM, our voice expresses the core of our personality, while bringing comfort, ease, and a sense of connection to our users. Through careful use of the IBM voice, we help empower users to meet their business goals.`}</p>
    <h3 {...{
      "id": "tone"
    }}>{`Tone`}</h3>
    <p>{`Tone conveys an attitude toward both the subject matter and the reader. All content – whether it’s introductory text on the UI, an error message, or a topic in the docs – tells part of a bigger story. Good storytellers are skilled in two main areas: what they are saying (the substantive content) and how to say it to any given audience (the style and tone in which it is presented). Be a good storyteller.`}</p>
    <h2 {...{
      "id": "conversational-levels"
    }}>{`Conversational levels`}</h2>
    <p>{`Content should never feel complex, distant, or disjointed. Rather, it should feel like a conversation with a smart friend – personal, relatable, helpful, and engaging. Do not mistake conversational style for sloppy writing! Conversational content still needs to be clear, concise, and easy to understand. The best content creates a connection with the user.`}</p>
    <p>{`Here’s a quick guide to conversational levels based on the six stages of the user journey:`}</p>
    <h3 {...{
      "id": "less-conversational"
    }}>{`Less conversational`}</h3>
    <h4 {...{
      "id": "instructional-content-for-how-to-complete-a-task-eg-steps"
    }}>{`Instructional content for how to complete a task (e.g. steps)`}</h4>
    <p>{`“Go to Avatar icon > Account > Notifications to set up general account and spending notifications. Spending notifications are available only for Subscription and Pay-As-You-Go account owners.”`}</p>
    <h3 {...{
      "id": "more-conversational"
    }}>{`More conversational`}</h3>
    <h4 {...{
      "id": "welcome-pages-and-standard-interface-content-for-productive-use-managing-and-upgrading-leverage-and-extend-content-and-support"
    }}>{`Welcome pages and standard interface content for productive use, managing and upgrading, leverage and extend content, and support`}</h4>
    <p>{`“To start using IBM Cloud, name your first organization. Think of an org as a project or team that shares resources, such as apps, databases, and other services. Orgs exist in geographic regions, so decide where you’d like to put your first one.”`}</p>
    <h3 {...{
      "id": "most-conversational"
    }}>{`Most conversational`}</h3>
    <h4 {...{
      "id": "discover-try-buy"
    }}>{`Discover, Try, Buy`}</h4>
    <p>{`“Watson Assistant comes pre-trained with industry-relevant content. It can make sense of your historical chat or call logs, and it has a visual dialog editor — meaning it’s never been easier to get started (developers not required).”`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      